import { useSelector } from "react-redux";
import { t } from "../../translations";
import "../styles/privacy-policy.css";

const PrivacyPolicy = () => {
  const lang = useSelector((state) => state.lang);

  return (
    <div className="privacyPolicy_body">
      <h1>{t("privacy_policy_page.main_title", lang)}</h1>

      <p>{t("privacy_policy_page.intro_para1", lang)}</p>

      <p>{t("privacy_policy_page.intro_para2", lang)}</p>

      <p>
        {t("privacy_policy_page.intro_para3", lang)}{" "}
        <a href="mailto:support@panichef.com">
          {t("privacy_policy_page.intro_para3_email", lang)}
        </a>{" "}
        {t("privacy_policy_page.intro_para3_continued", lang)}
      </p>

      <h2 className="h2-title" id="INFORMATIONS-COLLECTONS">
        {t("privacy_policy_page.section1_title", lang)}
      </h2>

      <p>{t("privacy_policy_page.section1_intro", lang)}</p>

      <h3>{t("privacy_policy_page.section1_subsection1_title", lang)}</h3>
      <p>{t("privacy_policy_page.section1_subsection1_content", lang)}</p>

      <h3>{t("privacy_policy_page.section1_subsection2_title", lang)}</h3>
      <p>{t("privacy_policy_page.section1_subsection2_content", lang)}</p>

      <h3>{t("privacy_policy_page.section1_subsection3_title", lang)}</h3>
      <p>{t("privacy_policy_page.section1_subsection3_content", lang)}</p>

      <h3>{t("privacy_policy_page.section1_subsection4_title", lang)}</h3>
      <p>{t("privacy_policy_page.section1_subsection4_intro", lang)}</p>

      <ul>
        <li>
          <strong>
            {t(
              "privacy_policy_page.section1_subsection4_list_item1_title",
              lang
            )}
          </strong>{" "}
          {t(
            "privacy_policy_page.section1_subsection4_list_item1_content",
            lang
          )}
        </li>
        <li>
          <strong>
            {t(
              "privacy_policy_page.section1_subsection4_list_item2_title",
              lang
            )}
          </strong>{" "}
          {t(
            "privacy_policy_page.section1_subsection4_list_item2_content",
            lang
          )}
        </li>
        <li>
          <strong>
            {t(
              "privacy_policy_page.section1_subsection4_list_item3_title",
              lang
            )}
          </strong>{" "}
          {t(
            "privacy_policy_page.section1_subsection4_list_item3_content",
            lang
          )}
        </li>
      </ul>

      <h3>{t("privacy_policy_page.section1_subsection5_title", lang)}</h3>
      <p>{t("privacy_policy_page.section1_subsection5_content", lang)}</p>

      <h3>{t("privacy_policy_page.section1_subsection6_title", lang)}</h3>
      <p>{t("privacy_policy_page.section1_subsection6_content", lang)}</p>

      <h3>{t("privacy_policy_page.section1_subsection7_title", lang)}</h3>
      <p>
        {t("privacy_policy_page.section1_subsection7_content", lang)}{" "}
        <a
          href="https://www.allaboutcookies.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("privacy_policy_page.section1_subsection7_link", lang)}
        </a>
        .
      </p>

      <h3>{t("privacy_policy_page.section1_subsection8_title", lang)}</h3>
      <p>{t("privacy_policy_page.section1_subsection8_content", lang)}</p>

      <h3>{t("privacy_policy_page.section1_subsection9_title", lang)}</h3>
      <p>
        {t("privacy_policy_page.section1_subsection9_content", lang)}{" "}
        <a
          href="https://www.google.com/policies/privacy/partners/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("privacy_policy_page.section1_subsection9_link1", lang)}
        </a>
        . {t("privacy_policy_page.section1_subsection9_content2", lang)}{" "}
        <a
          href="https://tools.google.com/dlpage/gaoptout"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("privacy_policy_page.section1_subsection9_link2", lang)}
        </a>{" "}
        {t("privacy_policy_page.section1_subsection9_content3", lang)}{" "}
        <a
          href="https://www.google.com/settings/ads/onweb/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("privacy_policy_page.section1_subsection9_link3", lang)}
        </a>{" "}
        {t("privacy_policy_page.section1_subsection9_content4", lang)}
      </p>

      <h3>{t("privacy_policy_page.section1_subsection10_title", lang)}</h3>
      <p>{t("privacy_policy_page.section1_subsection10_para1", lang)}</p>

      <p>{t("privacy_policy_page.section1_subsection10_para2", lang)}</p>

      <p>{t("privacy_policy_page.section1_subsection10_para3", lang)}</p>

      <p>
        {t("privacy_policy_page.section1_subsection10_para4", lang)}{" "}
        <a
          href="http://www.allaboutdnt.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("privacy_policy_page.section1_subsection10_link", lang)}
        </a>
        .
      </p>

      <h2 className="h2-title" id="COMMENT-NOUS-UTILISONS">
        {t("privacy_policy_page.section2_title", lang)}
      </h2>

      <p>{t("privacy_policy_page.section2_intro", lang)}</p>

      <ul>
        <li>{t("privacy_policy_page.section2_list_item1", lang)}</li>
        <li>{t("privacy_policy_page.section2_list_item2", lang)}</li>
        <li>{t("privacy_policy_page.section2_list_item3", lang)}</li>
        <li>{t("privacy_policy_page.section2_list_item4", lang)}</li>
        <li>{t("privacy_policy_page.section2_list_item5", lang)}</li>
        <li>{t("privacy_policy_page.section2_list_item6", lang)}</li>
        <li>{t("privacy_policy_page.section2_list_item7", lang)}</li>
        <li>{t("privacy_policy_page.section2_list_item8", lang)}</li>
        <li>{t("privacy_policy_page.section2_list_item9", lang)}</li>
        <li>{t("privacy_policy_page.section2_list_item10", lang)}</li>
        <li>{t("privacy_policy_page.section2_list_item11", lang)}</li>
        <li>{t("privacy_policy_page.section2_list_item12", lang)}</li>
      </ul>

      <h3>{t("privacy_policy_page.section2_subsection1_title", lang)}</h3>
      <p>{t("privacy_policy_page.section2_subsection1_content", lang)}</p>

      <h3>{t("privacy_policy_page.section2_subsection2_title", lang)}</h3>
      <p>
        {t("privacy_policy_page.section2_subsection2_content", lang)}{" "}
        <a href="mailto:support@panichef.com">
          {t("privacy_policy_page.section2_subsection2_email", lang)}
        </a>
        . {t("privacy_policy_page.section2_subsection2_continued", lang)}
      </p>

      <h2 className="h2-title" id="PARTAGE-ET-DIVULGATION">
        {t("privacy_policy_page.section3_title", lang)}
      </h2>

      <p>{t("privacy_policy_page.section3_intro", lang)}</p>

      <ul>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item1_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item1_content", lang)}
        </li>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item2_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item2_content", lang)}
        </li>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item3_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item3_content", lang)}
        </li>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item4_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item4_content", lang)}
        </li>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item5_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item5_content", lang)}
        </li>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item6_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item6_content", lang)}
        </li>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item7_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item7_content", lang)}
        </li>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item8_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item8_content", lang)}
        </li>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item9_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item9_content", lang)}
        </li>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item10_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item10_content", lang)}
        </li>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item11_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item11_content", lang)}
        </li>
        <li>
          <strong>
            {t("privacy_policy_page.section3_list_item12_title", lang)}
          </strong>{" "}
          {t("privacy_policy_page.section3_list_item12_content", lang)}
        </li>
      </ul>

      <p>{t("privacy_policy_page.section3_outro", lang)}</p>

      <h2 className="h2-title" id="VOS-DROITS-ET-CHOIX">
        {t("privacy_policy_page.section4_title", lang)}
      </h2>

      <p>{t("privacy_policy_page.section4_para1", lang)}</p>

      <ul>
        <li>
          <a
            href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("privacy_policy_page.section4_browser1", lang)}
          </a>
        </li>
        <li>
          <a
            href="https://support.mozilla.org/en-US/kb/block-websites-storing-cookies-site-data-firefox"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("privacy_policy_page.section4_browser2", lang)}
          </a>
        </li>
        <li>
          <a
            href="https://support.google.com/chrome/answer/95647?hl=en&co=GENIE.Platform%3DDesktop"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("privacy_policy_page.section4_browser3", lang)}
          </a>
        </li>
        <li>
          <a
            href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("privacy_policy_page.section4_browser4", lang)}
          </a>
        </li>
      </ul>

      <p>
        {t("privacy_policy_page.section4_para2", lang)}{" "}
        <a
          href="http://www.networkadvertising.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("privacy_policy_page.section4_link1", lang)}
        </a>{" "}
        {t("privacy_policy_page.section4_para2_continued", lang)}{" "}
        <a
          href="https://www.aboutads.info/choices"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("privacy_policy_page.section4_link2", lang)}
        </a>{" "}
        {t("privacy_policy_page.section4_para2_continued2", lang)}{" "}
        <a
          href="https://www.aboutads.info/appchoices"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("privacy_policy_page.section4_link3", lang)}
        </a>
        . {t("privacy_policy_page.section4_para2_continued3", lang)}
      </p>

      <p>{t("privacy_policy_page.section4_para3", lang)}</p>

      <h2 className="h2-title" id="CONSERVATION-ET-SUPPRESSION">
        {t("privacy_policy_page.section5_title", lang)}
      </h2>

      <p>{t("privacy_policy_page.section5_para1", lang)}</p>

      <p>
        {t("privacy_policy_page.section5_para2", lang)}{" "}
        <a href="mailto:support@panichef.com">
          {t("privacy_policy_page.section5_email", lang)}
        </a>
        .
      </p>

      <h2 className="h2-title" id="METTRE-A-JOUR-VOS-INFORMATIONS">
        {t("privacy_policy_page.section6_title", lang)}
      </h2>

      <p>
        {t("privacy_policy_page.section6_para1", lang)}{" "}
        <a href="mailto:support@panichef.com">
          {t("privacy_policy_page.section6_email", lang)}
        </a>{" "}
        {t("privacy_policy_page.section6_para1_continued", lang)}
      </p>

      <h2 className="h2-title" id="ENFANTS">
        {t("privacy_policy_page.section7_title", lang)}
      </h2>

      <p>
        {t("privacy_policy_page.section7_para1", lang)}{" "}
        <a href="mailto:support@panichef.com">
          {t("privacy_policy_page.section7_email", lang)}
        </a>{" "}
        {t("privacy_policy_page.section7_para1_continued", lang)}
      </p>

      <h2 className="h2-title" id="LIENS-VERS-AUTRES-SITES">
        {t("privacy_policy_page.section8_title", lang)}
      </h2>

      <p>{t("privacy_policy_page.section8_para1", lang)}</p>

      <h2 className="h2-title" id="SECURITE">
        {t("privacy_policy_page.section9_title", lang)}
      </h2>

      <p>{t("privacy_policy_page.section9_para1", lang)}</p>

      <h2 className="h2-title" id="MODIFICATIONS-POLITIQUE">
        {t("privacy_policy_page.section10_title", lang)}
      </h2>

      <p>{t("privacy_policy_page.section10_para1", lang)}</p>

      <h2 className="h2-title" id="CONTACTEZ-NOUS">
        {t("privacy_policy_page.section11_title", lang)}
      </h2>

      <p>
        {t("privacy_policy_page.section11_para1", lang)}{" "}
        <a href="mailto:support@panichef.com">
          {t("privacy_policy_page.section11_email", lang)}
        </a>
        .
      </p>

      <p>
        {t("privacy_policy_page.section11_para2", lang)}{" "}
        <a href="mailto:support@panichef.com">
          {t("privacy_policy_page.section11_email2", lang)}
        </a>
        .
      </p>

      <p>{t("privacy_policy_page.section11_para3", lang)}</p>

      <p>
        <strong>{t("privacy_policy_page.last_revised", lang)}</strong>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
